import { ProgressBar } from '../progress';
import styles from './index.module.scss';
import { Spinner } from './spinner';
import { Markdown } from '../markdown';
import { TLoadingOpts } from '@/stores/feedback';

export default function LoadingScreen({
  variant = 'overlay',
  hideProgressBar = false,
  content = '',
  progress = 100
}: TLoadingOpts) {
  return (
    <div className={styles.container} data-variant={variant}>
      <Spinner />
      {!hideProgressBar && (
        <div className={styles.progressBarWrapper}>
          <ProgressBar className={styles.progressBar} hideValue value={progress} />
        </div>
      )}
      {content.length > 0 && <Markdown className={styles.message} content={content} />}
    </div>
  );
}

export { LoadingScreen };
